export enum ContractType {
    NONE = 0,
    ZEROHOUR,
    SIXMONTHS,
    TWELVEMONTHS,
    INDEFINITLY,
    OTHER
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/enums/contractType.ts